import styled, { css } from 'styled-components';
import { useMixpanel } from 'hooks';
import { MouseEvent, ReactNode } from 'react';
import storageService from 'services/storageService';
import { MixpanelProps } from 'types/mixpanel';

export const linkStyles = css`
  color: ${props => props.theme.colors.siteBlack};
  background-color: transparent;
  text-decoration: none;
  font-size: 1.2rem;
  cursor: pointer;
  transition: none;
  &:hover,
  &:focus,
  &:active {
    color: ${props => props.theme.colors.siteBlack};
    text-decoration: none;
  }
  &:focus {
    outline: none !important;
  }
  &:active {
    outline: none !important;
  }
  &:disabled {
    opacity: 0.5;
  }
`;

export type LinkProps = {
  mixpanelProps?: MixpanelProps;
  newTab?: boolean;
  external?: boolean;
  to?: string | any;
  href?: string;
  blue?: boolean;
  white?: boolean;
  darkNavy?: boolean;
  tmpObjectToPass?: any;
  onClick?: (e: MouseEvent) => void;
  onMouseDown?: (e: MouseEvent) => void;
  children?: ReactNode;
  li?: boolean;
  selected?: boolean;
  target?: string;
  rel?: string;
  className?: string;
  disabled?: boolean;
};

const StyledLink = styled.a<LinkProps>`
  ${linkStyles}
`;

const DisabledLink = styled.span<LinkProps>`
  ${linkStyles}
  cursor: default;
  opacity: 0.8;
`;

const StyledRouterLink = styled.a<LinkProps>`
  ${linkStyles}
`;

export const Link = ({
  mixpanelProps,
  newTab,
  external,
  to,
  href,
  onClick,
  onMouseDown,
  tmpObjectToPass,
  className,
  disabled,
  ...props
}: LinkProps) => {
  const { logToMixpanel, incrementPeople } = useMixpanel();
  const onClickEvent = (e: MouseEvent) => {
    if (onClick) {
      onClick(e);
    }
    if (tmpObjectToPass) {
      storageService.set('ls.tmpObjectToPass', tmpObjectToPass); // save the object
    }
    if (mixpanelProps && mixpanelProps.object) {
      logToMixpanel(mixpanelProps.object);
    }
    if (mixpanelProps && mixpanelProps.people) {
      incrementPeople(mixpanelProps.people as string);
    }
  };
  const handleMouseDown = (e: MouseEvent) => {
    if (onMouseDown) {
      onMouseDown(e);
    }
  };

  if (external) {
    return (
      <StyledLink
        href={to || href}
        onClick={onClickEvent}
        target={newTab ? '_blank' : ''}
        className={className}
        {...props}
      />
    );
  }

  if (disabled) {
    return <DisabledLink className={className} disabled={disabled} {...props} />;
  }
  return (
    <StyledRouterLink
      onMouseDown={handleMouseDown}
      to={to}
      onClick={onClickEvent}
      target={newTab ? '_blank' : ''}
      className={className}
      {...props}
    />
  );
};

export default Link;
